export function Footer() {
  return (
    <footer className="relative px-5 md:px-8 pt-20 pb-8 border-t border-white/10">
      <div className="max-w-[1600px] mx-auto">
        <div className="font-display font-light text-[16vw] md:text-[13vw] leading-[0.86] tracking-[-0.03em] text-[rgb(var(--paper))]" data-testid="footer-mark">
          Nexeron <span className="italic font-serif text-[rgb(var(--brand))]">Studio.</span>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 gap-8 text-sm">
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[rgb(var(--paper-dim))] mb-3">Producto</div>
            <ul className="space-y-2 text-[rgb(var(--paper))]/80">
              <li><a href="#studio" className="link-fx">Studio</a></li>
              <li><a href="#trabajo" className="link-fx">Trabajo</a></li>
              <li><a href="#precios" className="link-fx">Precios</a></li>
            </ul>
          </div>
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[rgb(var(--paper-dim))] mb-3">Recursos</div>
            <ul className="space-y-2 text-[rgb(var(--paper))]/80">
              <li><a href="#pipeline" className="link-fx">Pipeline</a></li>
              <li><a href="#legal" className="link-fx">Legal</a></li>
            </ul>
          </div>
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[rgb(var(--paper-dim))] mb-3">Contacto</div>
            <ul className="space-y-2 text-[rgb(var(--paper))]/80">
              <li><a href="mailto:hola@nexeronstudio.app" className="link-fx">hola@nexeronstudio.app</a></li>
              <li><a href="#" className="link-fx">Instagram</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex items-end justify-between font-mono text-[10px] uppercase tracking-[0.28em] text-[rgb(var(--paper-dim))]">
          <span>© {new Date().getFullYear()} Nexeron Studio · All rights reserved</span>
          <span className="flex items-center gap-2"><span className="h-1.5 w-1.5 rounded-full bg-[rgb(var(--brand))] animate-pulse" /> Systems operational</span>
        </div>
      </div>
    </footer>
  );
}
